import { Period } from './Period'

export class OpeningHours {
    constructor(
        public days: OpeningHoursDay[]
    ) { }
}

export class OpeningHoursDay {
    constructor(
        public dayOfWeek: number,
        public periods: Period[]
    ) { }
}
